import script from "./PaymentDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentDetails.vue?vue&type=script&setup=true&lang=js"

import "./PaymentDetails.vue?vue&type=style&index=0&id=60022769&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60022769"]])

export default __exports__